import { apiClient } from "api";

export const getUserFeatures = () => {
	return apiClient.get(`conf/features`, {
		headers: {
			"Content-Type": "application/json",
		},
	});
};
